var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "direct-to-bag-active-bin-report"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "is-full-screen": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('legend', [_vm._v("Direct To Bag Active Bin Report")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.activelayout) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Layout")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layout),
      expression: "layout"
    }],
    ref: "layout",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "layout",
      "placeholder": "Enter layout No"
    },
    domProps: {
      "value": (_vm.layout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.layout = $event.target.value
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bay No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bayno),
      expression: "bayno"
    }],
    ref: "bayno",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "bayno",
      "placeholder": "Enter Bay No"
    },
    domProps: {
      "value": (_vm.bayno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bayno = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bin No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binno),
      expression: "binno"
    }],
    ref: "binno",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "binno",
      "placeholder": "Enter Bin No"
    },
    domProps: {
      "value": (_vm.binno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.binno = $event.target.value
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showBinDetails(true)
      }
    }
  }, [_vm._v("Show")]), _vm._v("  \n                "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])])], 1)]), _vm._v(" "), (_vm.displayList) ? _c('fieldset', [_c('legend', [_vm._v("Active Bin Details ( "), _c('span', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "lass": "float-right"
    }
  }, [_vm._v(_vm._s(_vm.listData.length))]), _vm._v(" )")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "table-action-bar"
  }, [_c('button', {
    staticClass: "common-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadCSV()
      }
    }
  }, [_vm._v("Download CSV")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Destination")]), _vm._v(" "), (_vm.activelayout) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Layout No")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bay No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin Barcode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Active Hours")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Details")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationHubName))]), _vm._v(" "), (_vm.activelayout) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.layoutNumber))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bayNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.binNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.binBarcode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createdDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.activeDuration))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showBinShipmentDetail(_vm.hubId, data.binBarcode, data.binNo, data.bayNo, data.layoutNumber)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.shipmentCount > 0) ? _c('span', {
      staticStyle: {
        "color": "rgb(32,168,216)",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Reset Bin"
      },
      on: {
        "click": function($event) {
          return _vm.openUpdateStatusModal(data)
        }
      }
    }, [_c('b', [_vm._v("Deactivate")])]) : _vm._e()])])
  }), 0)])])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount > 10),
      expression: "totalCount>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.showBinShipmentDetails == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Shipment Details"
    },
    model: {
      value: (_vm.showBinShipmentDetails),
      callback: function($$v) {
        _vm.showBinShipmentDetails = $$v
      },
      expression: "showBinShipmentDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bin Shipment Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeBinShipmentLog
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shippingid")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remove")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.binShipmentDetails), function(data, index) {
    return (_vm.binShipmentDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.binNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-trash text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      attrs: {
        "title": "Remove Shipment From Bin"
      },
      on: {
        "click": function($event) {
          return _vm.removeShipment(data.shipmentId)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.binShipmentDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.removeShipmentConfirmationModel),
      callback: function($$v) {
        _vm.removeShipmentConfirmationModel = $$v
      },
      expression: "removeShipmentConfirmationModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Are you sure you want to remove shipment "), _c('b', [_vm._v(_vm._s(_vm.shippingId))]), _vm._v(" from bin "), _c('b', [_vm._v(_vm._s(_vm.binNumber))]), _vm._v("?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.continueRemoveShipment
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.cancelRemoveShipment
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.UpdateStatusModal == true) ? _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.UpdateStatusModal),
      callback: function($$v) {
        _vm.UpdateStatusModal = $$v
      },
      expression: "UpdateStatusModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeUpdateStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Do you want to deactivate bin ?")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deactivateBin
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeUpdateStatusModal
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  })])])]) : _vm._e()], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-318d0b69","hasScoped":true}!./src/views/components/DirectToBag/DirectToBag.html
// module id = 2030
// module chunks = 2